import {
  Button,
  Card,
  CardBody,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Input,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { fetchController } from "../../../../utils/FetchController/fetchController";
import { toast } from "react-toastify";

export default function AccountInfo({
  baseUrl,
  authUser,
  agency,
  activatedPlan,
  getUserData,
}) {
  const { register, reset, handleSubmit } = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      businessName: "",
      phone: "",
      email: "",
      currentPlan: "",
    },
  });
  const [isLoading, setIsLoading] = useState(false);
  const { buttonColorScheme } = agency;

  useEffect(() => {
    if (authUser) {
      const { first_name, last_name, phone, email, business_name } = authUser;
      reset({
        firstName: first_name,
        lastName: last_name,
        businessName: business_name || "",
        phone,
        email,
        currentPlan: activatedPlan.name,
      });
    }
  }, [authUser]);

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      const payload = {
        first_name: data.firstName,
        last_name: data.lastName,
        business_name: data.businessName,
        phone: data.phone,
      };
      const response = await fetchController(
        `${baseUrl}/api/v1/user/${authUser?.id}`,
        "PUT",
        payload
      );
      toast.success(response?.message || "User details updated successfully");
      getUserData();
    } catch (e) {
      console.error(e);
      toast.error(e?.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card maxW={"900px"} variant={"elevated"}>
      <CardBody>
        <form onSubmit={(e) => { e.preventDefault(); handleSubmit(onSubmit)(); }}>
          <Flex flexDirection="column" gap={4}>
            <FormControl>
              <FormLabel>First Name</FormLabel>
              <Input
                htmlSize={50}
                width="auto"
                placeholder="John"
                {...register("firstName")}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Last Name</FormLabel>
              <Input
                htmlSize={50}
                width="auto"
                placeholder="Doe"
                {...register("lastName")}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Business Name</FormLabel>
              <Input
                htmlSize={50}
                width="auto"
                placeholder="Optional"
                {...register("businessName")}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Phone number</FormLabel>
              <Input
                htmlSize={50}
                width="auto"
                placeholder="Optional"
                {...register("phone")}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Email</FormLabel>
              <HStack gap={2}>
                <Input
                  htmlSize={50}
                  width="auto"
                  {...register("email")}
                  variant={"filled"}
                  isDisabled
                />
                <Button
                  colorScheme={buttonColorScheme || "blue"}
                  variant="outline"
                  size="sm"
                  onClick={() => {
                    window.location.href =
                      "mailto:support@insighto.ai?subject=Request%20for%20Email%20Correction&body=Please%20describe%20the%20correction%20needed:";
                  }}
                >
                  Request Correction
                </Button>
              </HStack>
            </FormControl>

            <FormControl>
              <FormLabel>Current Plan</FormLabel>
              <Input
                htmlSize={50}
                width="auto"
                {...register("currentPlan")}
                variant={"filled"}
                isDisabled
              />
            </FormControl>

            <Flex justify="flex-end">
              <Button
                colorScheme={buttonColorScheme || "blue"}
                type="button"
                onClick={() => handleSubmit(onSubmit)()}
                isLoading={isLoading}
              >
                Save Changes
              </Button>
            </Flex>
          </Flex>
        </form>
      </CardBody>
    </Card>
  );
}
